import { global } from ":shared/app";

export type GET = {
  props: {
    email: string;
  };
  returns: {
    email: string;
    first_name: string;
    last_name: string;
    attendance_status: boolean;
  };
};

const endpoint = (email: string) => "account/attendance?email=" + email;
export async function get(props: GET["props"]): Promise<GET["returns"]> {
  return global.api.get(endpoint(props.email)).then((res) => {
    return res.data;
  });
}
